<template>
  <div class="visualization-controls__select">
    <label for="county">County:</label>
    <multiselect
      :options="countyOptions"
      :multiple="true"
      :close-on-select="true"
      :clear-on-select="true"
      :preserve-search="false"
      :show-labels="false"
      :value="countySelections"
      @input="setCountySelection"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  computed: {
    countyOptions() {
      return this.$store.state.visualization.counties;
    },
    countySelections() {
      return this.$store.state.visualization.countySelections;
    },
  },

  async created() {
    const {
      data: { counties },
    } = await this.$axios.get("/api/sample_totals/counties");
    const filteredCounties = counties.filter(
      (c) => c.toLowerCase() !== "statewide"
    );
    this.setCounties(filteredCounties);
  },

  methods: {
    ...mapMutations({
      setCounties: "visualization/setCounties",
      setCountySelections: "visualization/setCountySelections",
    }),
    setCountySelection(counties) {
      // this.$store.commit("visualization/setCountySelections", counties);
      this.setCountySelections(counties);
      this.$emit("child-changed");
    },
  },
};
</script>

<style lang="scss" scoped>
// .multiselect {
//   width: 270px;
// }
</style>
